import api from './api';

const prefix = '/design-studio';

const designStudioService = {
  // Create a new chat session
  createSession: async (projectId, title = null) => {
    const response = await api.post(`${prefix}/sessions`, {
      projectId,
      title,
    });
    return response.data;
  },

  // Get all sessions for a project
  getSessions: async (projectId) => {
    const response = await api.get(`${prefix}/sessions`, {
      params: { projectId },
    });
    return response.data;
  },

  // Get a specific session
  getSession: async (sessionId) => {
    const response = await api.get(`${prefix}/sessions/${sessionId}`);
    return response.data;
  },

  // Send a message in a session
  sendMessage: async (sessionId, message, { includeProtocolContext = false } = {}) => {
    const response = await api.post(`${prefix}/sessions/${sessionId}/messages`, {
      message,
      includeProtocolContext,
    });
    return response.data;
  },

  // Delete a session
  deleteSession: async (sessionId) => {
    const response = await api.delete(`${prefix}/sessions/${sessionId}`);
    return response.data;
  },

  // Upload a document to a session
  uploadDocument: async (sessionId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(`${prefix}/sessions/${sessionId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete an uploaded document from a session
  deleteUploadedDocument: async (sessionId, documentId) => {
    const response = await api.delete(`${prefix}/sessions/${sessionId}/documents/${documentId}`);
    return response.data;
  },

  // Restore lost sections from chat history
  restoreSections: async (sessionId) => {
    const response = await api.post(`${prefix}/sessions/${sessionId}/restore-sections`);
    return response.data;
  },

  // Regenerate a single section in the generated document
  regenerateSection: async (sessionId, sectionId, prompt) => {
    const response = await api.post(`${prefix}/sessions/${sessionId}/sections/${sectionId}/regenerate`, {
      prompt,
    });
    return response.data;
  },

  // Get the document structure for a session
  getStructure: async (sessionId) => {
    const response = await api.get(`${prefix}/sessions/${sessionId}/structure`);
    return response.data;
  },

  // Update the document structure for a session
  updateStructure: async (sessionId, structure) => {
    const response = await api.post(`${prefix}/sessions/${sessionId}/structure`, {
      structure,
    });
    return response.data;
  },

  // Ask LLM to suggest sections for a document type / custom name
  suggestSections: async (documentType, customDocumentName = '') => {
    const response = await api.post(`${prefix}/suggest-sections`, {
      documentType,
      customDocumentName,
    });
    return response.data;
  },
};

export default designStudioService;

